Vue.component('profileselect', {
    props: {
        search: {
            type: Object
        },
        updates: {
            type: Number
        },
        isLoadingTable: {
            type: Boolean
        },
        dataset: {
            type: String
        },
        datafieldsdata: {
            type: Object
        },
        datafieldids: {
            type: String
        },
        fielddata: {},
        districtdata: {},
    },
    data () {
        return {            
            minMax: {},
            isLoaded: false,
            isStarted: false,
            selectedData: {},
            searchData: {},
            activeDistrict: false,
            matchedDistricts: {},
            isUpdating: false,
            pendingChange: true,
            peerSlidersLoaded: false,
            maxRecommend: 10
        }
    },
    computed: {
        datafields () {
            return JSON.parse(this.datafieldids);
        },
        backgroundfields () {
            return JSON.parse(this.backgroundids)
        },
        noPeerDistricts () {
            if (this.isUpdating) {return "Fetching peers...";}
            if (Object.entries(this.matchedDistricts).length > 0) {return false;}            
            return 'No Peers Selected Yet';
        },
        peerDistricts () {
            if (this.noPeerDistricts) {return false;}
            let peers = {}
            for (let i = 0; i < this.matchedDistricts.shared.length; i++) {
                if (this.districtdata[this.matchedDistricts.shared[i]] && this.matchedDistricts.shared[i] != this.activeDistrict) {                
                    peers[this.matchedDistricts.shared[i]] = this.districtdata[this.matchedDistricts.shared[i]];
                }
            }
            if (Object.entries(peers).length === 0) {return false;}
            return peers;
        },
        peerDistrictNumber () {
            if (!this.peerDistricts) {return 0;}
            return formatSlideData (Object.entries(this.peerDistricts).length, "Number");
        },
        peerMessage () {
            if (this.peerDistrictNumber > this.maxRecommend) {
                return 'We recommend no more than ' + this.maxRecommend + ' peers for the best experience';
            }
            return false;
        },
        updateButtonText () {
            if (this.isLoading) {return "Loading...";}
            if (this.pendingChange) {return "Update Peers";}
            return "Peers Selected"
        }
    },
    async created () {
        // get max & min for each field
        // one query
        let $this = this;
        let obj = new FormData;
        //let df = this.datafields.filter(item => $this.fielddata[item * 1].data_format != "Text");
        
        let data_field_ids = JSON.stringify(this.datafields);   
                
        let params = '{"fields":' + data_field_ids + '}';        
        //let params = JSON.stringify(paramsobj);
        obj.append('action', 'slide_get_minmax');
        obj.append('params', params);
        let data = await axios.post(axios_ajax.ajaxurl, obj);        
        this.minMax = data.data;
        
    },
    methods: {
        async getprofiledistrictdata (p) {
            this.$refs.slide_profile_districts.classList.add('sliding');
            this.$refs.profile_demographics_wrapper.classList.add('sliding');
            this.$refs.slide_profile_select.classList.add('started');
            this.isStarted = true;
            let nces_id = p.nces_id;
            this.activeDistrict = nces_id;
            let obj = new FormData;
            obj.append('action', 'slide_get_search_data');
            let data_field_ids = JSON.stringify(this.datafields);            
            let params = '{"filters":{"nces_id":["' + nces_id + '"],"data_field_id":' + data_field_ids + '},"fields":{}}';            
            obj.append('params', params);
            let data = await axios.post(axios_ajax.ajaxurl, obj);
            this.peerSlidersLoaded = true;
            let selectedData = {};
            for (const d in data.data) {            
                let thisd = data.data[d];
                selectedData[thisd.data_field_id] = thisd.data_value;
            }
            
            let action = 'slide_get_agency_info';
            obj = new FormData;
            obj.append('action', action);
            obj.append('nces_id', nces_id);

            let perfObj = {
                method: "post",
                url: axios_ajax.ajaxurl,
                obj: obj,
                action: action                
            };
            data = await slidePerf(perfObj);
            //data = await axios.post(axios_ajax.ajaxurl, obj);
            selectedData[agencyStateFauxKey] = data.data.StAbr;
            
            if (this.datafieldsdata[agencyStateFauxKey].selected) {
                this.searchData[agencyStateFauxKey] = {val: data.data.StAbr};  
            }            


            this.selectedData = selectedData;

            this.$nextTick(function() {
                this.getPeers();
            })
            this.$emit('setfeatured', nces_id);
        },
        resetprofile () {
            this.$refs.slide_profile_districts.classList.remove('sliding');
            this.$refs.profile_demographics_wrapper.classList.remove('sliding');
            this.$refs.slide_profile_select.classList.remove('started');
            this.matchedDistricts = {};
            this.selectedData = {};
        },
        
        updaterange (field, start, end) {
            this.pendingChange = true;
            if (start == -999 && end == -999) {
                delete this.searchData[field.data_field_id]
                return;
            }
            this.searchData[field.data_field_id] = {};
            this.searchData[field.data_field_id].start = start;
            this.searchData[field.data_field_id].end = end;
            
        },
        updateboolean (field, val) {
            this.pendingChange = true;
            if (val == -999) {
                delete this.searchData[field.data_field_id]
                return;
            }
            this.searchData[field.data_field_id] = {};
            this.searchData[field.data_field_id].val = val;                    
        },
        updatecategory (field, vals) {
            this.pendingChange = true;
            if (vals == -999) {
                delete this.searchData[field.data_field_id]
                return;
            }
            this.searchData[field.data_field_id] = {};
            let valarray = [];
            for (const val in vals) {
                if (vals[val]) {
                    valarray.push(val)
                }
            } 
            this.searchData[field.data_field_id].val = valarray;
            
        },
        updatenone (field, val) {
            this.pendingChange = true;
            if (!val) {
                delete this.searchData[field.data_field_id]
                return;
            }
            this.searchData[field.data_field_id] = {};
            this.searchData[field.data_field_id].val = this.selectedData[field.data_field_id];
        },
        async getPeers () {
            this.isUpdating = true;
            let obj = new FormData;
            obj.append('action', 'slide_get_districts');
            let params = {searchData: this.searchData};
            params = JSON.stringify(params);
            //console.log("🚀 ~ file: profileselect.js ~ line 166 ~ getPeers ~ this.searchData", this.searchData)
            obj.append('params', params)
            let data = await axios.post(axios_ajax.ajaxurl, obj);
            this.matchedDistricts = data.data;
                                    
            this.$nextTick(function() {

                let arr = [];
                arr.push(this.districtdata[this.activeDistrict])
                for (d in this.peerDistricts) {
                    arr.push(this.peerDistricts[d])
                }

                let filtervalues = {
                    field: 'nces_id',
                    selected: arr,
                    key: 'nces_id'
                }
                this.$emit("updatesearch", 'filters', filtervalues);
            })
            

            this.isUpdating = false;
            this.pendingChange = false;            
            this.$emit("setpeerdistricts", this.peerDistricts);            
        },
        updatesearch (type, values) {
            this.$emit('updatesearch', type, values);            
        },   
        show (field) {
            if (!this.selectedData[field]) {
                return false;
            }
            return true;
        },
        // functions for child items that other parents need
        isloading () {}, isloaded () {}, fielddataloaded() {}, districtdataloaded() {},      
    }
})
